import React from 'react'
import styled from 'styled-components'
import getUtilityData from '../resources/utility_type'

export const TagInfo = ({ device_tag, status, line, utility, measurement }): JSX.Element => {
    let componentResources = getUtilityData(utility?.toLowerCase(), 'CONSUMPTION') 
    

    let statusColor =
        status?.toLowerCase() == 'online'
            ? '#00BA4A'
            : status?.toLowerCase() == 'offline'
            ? 'grey'
            : status?.toLowerCase() == 'undefined'
            ? 'orange'
            : 'black'

    return (
        <Tag statusColor={statusColor}>
            <table style={{ width: '100%' }}>
                <tr className="tag-title">
                    <td style={{ width: '2%' }} className="status-color" />
                    <td style={{ width: '43%' }}>{device_tag}</td>
                    <td style={{ width: '30%' }}></td>
                    <td className="status-title">{status?.toUpperCase()}</td>
                </tr>
                <tr>
                    <td className="status-color" />
                    <td style={{ borderRight: '1px solid #C1C1C1' }}>Line</td>
                    <td style={{ borderRight: '1px solid #C1C1C1' }}>Utility</td>
                    <td>Measurement</td>
                </tr>
                <tr className="tag-data">
                    <td className="status-color" />
                    <td style={{ borderRight: '1px solid #C1C1C1' }}>{line}</td>
                    <td style={{ borderRight: '1px solid #C1C1C1' }}>
                    <i className={componentResources?.icon} /> {utility?.toUpperCase()}
                    </td>
                    <td>
                        {measurement} {componentResources?.unitMeasurement}
                    </td>
                </tr>
                <tr>
                    <td className="status-color" />
                </tr>
            </table>
        </Tag>
    )
}

const Tag = styled.div`
    border: 1px solid #e0e0e0;
    height: 10%;
    color: #364159;
    width: 100%;
    margin-bottom: 10px;

    .tag-title {
        font-size: 15px;
        font-weight: bold;
    }

    .status-title {
        color: ${props => props.statusColor || 'black'};
        padding: 15px;
        float: right;
    }

    .status-color {
        width: 6px;
        background-color: ${props => props.statusColor || 'black'};
        padding: 1px;
    }

    td {
        padding: 3px;
        padding-left: 10px;
    }

    .tag-data {
        font-weight: bold;
        font-size: 13px;
    }
`
